import { render, staticRenderFns } from "./RecordPrepaymentModal.vue?vue&type=template&id=45a18ea3&scoped=true&"
import script from "./RecordPrepaymentModal.vue?vue&type=script&lang=ts&"
export * from "./RecordPrepaymentModal.vue?vue&type=script&lang=ts&"
import style0 from "./RecordPrepaymentModal.vue?vue&type=style&index=0&id=45a18ea3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a18ea3",
  null
  
)

export default component.exports